import { FETCH_SUGGESTIONS } from './constants'

const initialState = {
  isFetching: false,
  suggestions: []
}

export default function searchReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUGGESTIONS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_SUGGESTIONS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        suggestions: action.results
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/ESSearch/reducer.js